export default __webpack_public_path__ + "static/raven-1-b89e9c11325a02567dead668d5bf58dd.webp";